/* =====================================================================
   PANORAMA WIDE — comportements progressifs
   Principe : sans JavaScript, tout le contenu est visible et chaque
   chiffre affiche sa valeur finale, écrite en dur dans le HTML.
   Le script ne fait qu'animer ce qui existe déjà.
   ===================================================================== */
(() => {
  'use strict';

  // Le script est chargé : on annule le filet de secours posé dans le <head>.
  if (window.__panoramaSecours) clearTimeout(window.__panoramaSecours);

  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;

  /* -------------------------------------------------------------------
     1. Apparitions et filets tracés
     .apparait : fondu et léger glissement (à réserver à quelques blocs)
     .trace    : les filets et barres du bloc se tracent de gauche à droite
     ------------------------------------------------------------------- */
  const animes = document.querySelectorAll('.apparait, .trace');

  // Décalages en cascade : --i par ligne, --j par cellule
  document.querySelectorAll('.trace').forEach((bloc) => {
    bloc.querySelectorAll('.checklist > li, tbody > tr, .barres > li').forEach((ligne, i) => {
      ligne.style.setProperty('--i', i);
      if (ligne.tagName === 'TR') {
        [...ligne.children].forEach((cellule, j) => cellule.style.setProperty('--j', j));
      }
    });
  });

  if (!io || reduit) {
    animes.forEach((el) => el.classList.add('est-visible'));
  } else {
    const obs = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('est-visible');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    animes.forEach((el) => obs.observe(el));
  }

  /* -------------------------------------------------------------------
     2. Chiffres qui défilent
     <span data-compte>27 248</span> : la valeur finale reste lisible par
     les lecteurs d'écran et les robots ; seule la copie visible s'anime.
     ------------------------------------------------------------------- */
  const lire = (texte) => {
    const brut = texte.replace(/[\s\u00a0\u202f]/g, '').replace(',', '.');
    return { n: parseFloat(brut), decimales: (brut.split('.')[1] || '').length };
  };

  const compteurs = [...document.querySelectorAll('[data-compte]')].map((el) => {
    const final = el.textContent.trim();
    const { n, decimales } = lire(final);
    if (!Number.isFinite(n)) return null;

    const pourLecteurs = document.createElement('span');
    pourLecteurs.className = 'sr-only';
    pourLecteurs.textContent = final;

    const visible = document.createElement('span');
    visible.setAttribute('aria-hidden', 'true');
    visible.textContent = final;

    el.textContent = '';
    el.append(pourLecteurs, visible);
    return { el, visible, n, decimales, final };
  }).filter(Boolean);

  const defiler = ({ visible, n, decimales, final }) => {
    const format = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: decimales,
      maximumFractionDigits: decimales,
    });
    const duree = 1400;
    let depart;
    const pas = (t) => {
      if (depart === undefined) depart = t;
      const p = Math.min((t - depart) / duree, 1);
      const e = 1 - Math.pow(1 - p, 3);
      visible.textContent = p < 1 ? format.format(n * e) : final;
      if (p < 1) requestAnimationFrame(pas);
    };
    visible.textContent = format.format(0);
    requestAnimationFrame(pas);
  };

  if (io && !reduit && compteurs.length) {
    const obsChiffres = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        const c = compteurs.find((x) => x.el === e.target);
        if (c) defiler(c);
        obsChiffres.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    compteurs.forEach((c) => obsChiffres.observe(c.el));
  }

  /* -------------------------------------------------------------------
     3. Sommaire du chapitre : repère de la section en cours
     ------------------------------------------------------------------- */
  const toc = document.querySelector('.rail__toc');
  if (toc && io) {
    const liens = [...toc.querySelectorAll('a[href^="#"]')];
    const cibles = liens.map((a) => document.getElementById(a.hash.slice(1))).filter(Boolean);
    const obsToc = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        liens.forEach((a) => a.toggleAttribute('aria-current', a.hash === '#' + e.target.id));
      });
    }, { rootMargin: '-15% 0px -75% 0px' });
    cibles.forEach((c) => obsToc.observe(c));
  }

  /* -------------------------------------------------------------------
     4. Copier la référence
     ------------------------------------------------------------------- */
  document.querySelectorAll('[data-copier]').forEach((bouton) => {
    const source = document.querySelector(bouton.dataset.copier);
    if (!source || !navigator.clipboard) return;
    const libelle = bouton.textContent;
    bouton.hidden = false;
    bouton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(source.textContent.replace(/\s+/g, ' ').trim());
        bouton.textContent = 'Référence copiée';
        setTimeout(() => { bouton.textContent = libelle; }, 2500);
      } catch (_) { /* copie refusée : la référence reste sélectionnable */ }
    });
  });
})();
